module.exports = __webpack_public_path__ + "assets/b22.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b22.png
// module id = 608
// module chunks = 0